import { jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { useHexInput } from "./hooks/useHexInput.js";
import { HexInputAdornment } from "./components/HexInputAdornment.js";
function HexInput() {
  const { onClick, onTextChange, showCopied, textFieldValue, value, readonly, onBlur } = useHexInput();
  return /* @__PURE__ */ jsx(
    TextField,
    {
      "data-testid": "TidalColorPickerHexInput",
      value: textFieldValue,
      onChange: onTextChange,
      onBlur,
      fullWidth: true,
      InputProps: {
        readOnly: readonly,
        startAdornment: /* @__PURE__ */ jsx(HexInputAdornment, { onClick, showCopied, color: value })
      }
    }
  );
}
export {
  HexInput
};
//# sourceMappingURL=HexInput.js.map
